import { makeStyles } from '@material-ui/core';
import LinuxellLogo from './linuxell-logo.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 32,
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <img className={classes.img} src={LinuxellLogo} alt="Linuxell" />;
};
